﻿
/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true
*/
window.nodewebservicecredentials = function () {

    /**
    * Enable save button
    */
    function enableSaveButton() {
        var btnSave = document.getElementById("saveButton");
        btnSave.removeAttribute("disabled");
    }

    function LDataChangedNotSavedYet() {
        return _msg_notsaved;
    }

    return {

        initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },


        /**
        * Move user to the left
        */
        leftClicked: function () {
            enableSaveButton();
            listbox.moveItems("NodeWebServiceCredentials_CplSelected", "NodeWebServiceCredentials_CplNotSelected", "#NodeWebServiceCredentials_Validation", LDataChangedNotSavedYet);
        },

        /**
        * Move user to the right
        */
        rightClicked: function () {
            enableSaveButton();
            listbox.moveItems("NodeWebServiceCredentials_CplNotSelected", "NodeWebServiceCredentials_CplSelected", "#NodeWebServiceCredentials_Validation", LDataChangedNotSavedYet);
        },

        /**
        * Save button clicked
        */
        saveButtonClicked: function (actionUrl, groupId) {            

            var json = $("#NodeWebServiceCredentials_CplSelected").data("kendoListBox").dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), id: groupId },
                success: function (responseData) {

                    $('#NodeWebServiceCredentials_Validation').text("");

                    var color = (responseData.Succesfully ? 'green' : 'red');
                    $('#NodeWebServiceCredentials_Validation').text(responseData.Message);
                    $('#NodeWebServiceCredentials_Validation').attr('style', 'color:' + color);

                    var btnSave = document.getElementById("saveButton");
                    btnSave.setAttribute("disabled", "disabled");
                }
            });
        }

    }

}();